import { FieldKey } from '@core/data-access/models/dynamic-form-field/dynamic-form-field.model';
import { FormValues } from '@core/data-access/models/form/form.model';
import { isEmptyFormValue, sanitizeAndNormalizeFormValues } from '@core/utils/form-helpers';
import { TranslateService } from '@ngx-translate/core';
import { intersection, isEqual, keys, omitBy, pick } from 'lodash';

export const areBuyerFormsFieldsEqual = (
  savedBuyerFields: object,
  previousBuyerInformationFormFields: object,
  currentBuyerInformationFormFields: object,
  translateService: TranslateService
) => {
  const savedBuyerFieldsWithValue = omitBy(savedBuyerFields, isEmptyFormValue);
  const buyerInformationFieldsWithValue = omitBy(
    currentBuyerInformationFormFields,
    (formField: string, fieldKey: FieldKey) =>
      isEmptyFormValue(formField) && isEmptyFormValue(previousBuyerInformationFormFields[fieldKey])
  );

  const commonKeysWithValue = intersection(keys(savedBuyerFieldsWithValue), keys(buyerInformationFieldsWithValue));
  const cleanedSavedBuyerFields = pick(savedBuyerFieldsWithValue, commonKeysWithValue) as FormValues;
  const cleanedBuyerInformationFields = pick(buyerInformationFieldsWithValue, commonKeysWithValue) as FormValues;

  return isEqual(
    sanitizeAndNormalizeFormValues(cleanedSavedBuyerFields, translateService),
    sanitizeAndNormalizeFormValues(cleanedBuyerInformationFields, translateService)
  );
};
